import * as types from '../mutation-types'
import { API } from '../../api';
import { REPORT_DATA_MANAGER } from '../../data';
import { CONFIG } from '../../config';

export default {
    namespaced: true,
    state: {
        gotAIConfig: false,
        aiConfigData: {},
        productList: {},
        productData: {},
        detailInfo: {},
        getReportTimes: 0,
        reportData: {},
        reportAIData: {}
    },
    mutations: {},
    actions: {
        // 获取测算配置信息
        initReportAIConfig({state}) {
            API.getAIConfig({}, function(data) {
                state.gotAIConfig = true;
                state.aiConfigData = data;
                var resultData = REPORT_DATA_MANAGER.getProductDataByData(data.product);
                state.productList = resultData.productList;
                state.productData = resultData.productData;
                console.log('获取测算配置信息成功:::::::', data, state.productList, state.productData)
            });
        },
        // 根据id获取测评报告信息
        getReportInfo({state}, params) {
            state.detailInfo = params.detailInfo;
            API.getAIInfo({
                id: params.detailInfo.id
            }, function(data) {
                console.log('获取测评数据成功:::::::', data);
                state.reportData = data;
                state.reportAIData = REPORT_DATA_MANAGER.getReportAIDataByData(data.ai);

                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            });
        },
        // 支付完成之后，根据id刷新测评报告信息
        updateReportInfo({state}, detailId) {
            function getReportInfo(id) {
                API.getAIInfo({
                    id: id
                }, function(data) {
                    console.log('更新测评数据成功:::::::', data, state.getReportTimes);
                    state.reportData = data;
                    state.reportAIData = REPORT_DATA_MANAGER.getReportAIDataByData(data.ai);
                    state.getReportTimes++;
                    var times = CONFIG.platform == 'web' ? 5 : 3;
                    if(state.getReportTimes < times) {
                        setTimeout(() => {
                            getReportInfo(detailId);
                        }, 1000);
                    }
                });
            }
            getReportInfo(detailId);
        },
        useReportFree({state}, params) {
            console.log('useReportFree------', params)
            API.useFree({
                id: params.id
            }, function(data) {
                console.log('更新测评数据成功:::::::', data.info, state.getReportTimes)
                state.aiConfigData.freeTimes = data.freeTimes;
                state.reportData = data.info;
                state.reportAIData = REPORT_DATA_MANAGER.getReportAIDataByData(data.info.ai);

                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        resetData({state}) {
            state.gotAIConfig = false;
            state.aiConfigData = {};
            state.productList = {};
            state.productData = {};
            
            state.detailInfo = {};
            state.getReportTimes = 0;
            state.reportData = {};
            state.reportAIData = {};
        },
        resetReportData({state}) {
            state.detailInfo = {};
            state.getReportTimes = 0;
            state.reportData = {};
            state.reportAIData = {};
        }
    }
}
